import React, { useRef, useEffect, useState, useMemo } from 'react';
import YearSection from './YearSection';
import { featuresData } from '../data/featuresData';
import { countVisibleYears } from '../utils/filterUtils';
import './Timeline.css';

const Timeline = ({ activeFilter, activeCategoryFilters, onCategoryFilterToggle }) => {
  const containerRef = useRef(null);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [shouldPlayAnimation, setShouldPlayAnimation] = useState(false);

  useEffect(() => {
    // Check if peek animation has been shown before
    try {
      const peekAnimationShown = localStorage.getItem('peekAnimationShown');

      if (!peekAnimationShown) {
        setShouldPlayAnimation(true);
        localStorage.setItem('peekAnimationShown', 'true');
      }
    } catch (error) {
      console.warn('Unable to access localStorage for peek animation flag:', error);
    }
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      if (container.scrollLeft > 50) {
        setHasScrolled(true);
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  // Memoize the visible year count calculation
  const visibleYearCount = useMemo(() => {
    return countVisibleYears(featuresData, activeFilter, activeCategoryFilters);
  }, [activeFilter, activeCategoryFilters]);

  const shouldCenter = visibleYearCount <= 4;

  // Memoize the rendered year sections
  const renderedYearSections = useMemo(() => {
    return featuresData.slice().reverse().map((yearData) => {
      return (
        <YearSection
          key={yearData.year}
          year={yearData.year}
          categories={yearData.sections}
          activeFilter={activeFilter}
          activeCategoryFilters={activeCategoryFilters}
          onCategoryFilterToggle={onCategoryFilterToggle}
        />
      );
    }).filter(Boolean);
  }, [activeFilter, activeCategoryFilters, onCategoryFilterToggle]);

  return (
    <section className="main-content" ref={containerRef} aria-label="Features timeline">
      <div className={`container ${hasScrolled ? 'scrolled' : ''}`}>
        <div className={`year-grid ${shouldPlayAnimation ? 'play-peek-animation' : ''} ${shouldCenter ? 'center-items' : ''}`}>
          {renderedYearSections}
        </div>
      </div>
    </section>
  );
};

export default Timeline;